const { isNil, forEach } = require('ramda')

module.exports = {
  subscribeTo (stream, fn) {
    stream.subscribe(fn)
    if (isNil(this.streamListeners)) {
      this.streamListeners = []
    }
    this.streamListeners.push([ stream, fn ])
  },

  componentWillUnmount () {
    if (this.streamListeners != null) {
      forEach((pair) => {
        pair[0].unsubscribe(pair[1])
      }, this.streamListeners)
    }
  },

}
